import { EventItemWithServiceInfo, RBAssetEntityType } from '../../types';

function isEventItemWithServiceInfoItem(
    item: any,
): item is EventItemWithServiceInfo {
    return item.entityType === RBAssetEntityType.EventItemWithServiceInfo;
}

export default isEventItemWithServiceInfoItem;
